const GET_SUPPLIER = "GET_SUPPLIER";
const GET_SUPPLIER_SUCCESS = "GET_SUPPLIER_SUCCESS";
const GET_SUPPLIER_FAIL = "GET_SUPPLIER_FAIL";

const GET_ACCOUNT = "GET_ACCOUNT";
const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS";
const GET_ACCOUNT_FAIL = "GET_ACCOUNT_FAIL";

const BASE_ENDPOINT = "";
const initialValues = {
  loading: false,
  hasError: false,
  data: {    
    availablesCUIT: [],
    accountData: [],
  }
}

const supplier = (state = initialValues, action) => {
  switch (action.type) {
    case GET_SUPPLIER: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SUPPLIER_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_SUPPLIER_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_ACCOUNT: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_ACCOUNT_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          accountData: action.payload.data
        },
        loading: false,
      };
    }

    case GET_ACCOUNT_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
   
    default: {
      return state;
    }
  }
};

export const getSupplierCuit = (email) => {
  // HARDCODED
  /* if(email=="TEIC@TEIC.COM"){
    email="cpaviglianiti@softtek.com"
  } */
  
  return {
    type: GET_SUPPLIER,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + `/Supplier/Information/FiscalData?email=${email}`,
      },
    },
  };
};

export const getAccountData = (email, nif) => {
  // HARDCODED
  /* if(email=="TEIC@TEIC.COM"){
    email="cpaviglianiti@softtek.com"
    //nif="30-68151999-4"
  } */
  
  return {
    type: GET_ACCOUNT,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + `/Supplier/AccountStatus?supplierEmail=${email}&supplierNif=${nif}`,
      },
    },
  };
};

export default supplier;
